import { useDynamicViewSchema } from "src/dynamic-view-renderer/DynamicViewSchemaProvider/DynamicViewSchemaProvider";
import { getAlertCase, getAlertCaseSummary } from "src/services/alert";
import { AlertWithCase, AlertWithCaseSummary } from "src/types/alert";
import { Case, CaseSummary } from "src/types/case";

export const useGetAlertCase = () => {
  const uiSchema = useDynamicViewSchema();
  const defaultAlertVersion = uiSchema.defaultAlertVersion;
  return (alert: AlertWithCase): Case | null => getAlertCase(alert, defaultAlertVersion);
};

export const useGetAlertCaseSummary = () => {
  const uiSchema = useDynamicViewSchema();
  const defaultAlertVersion = uiSchema.defaultAlertVersion;
  return (alert: AlertWithCaseSummary): CaseSummary | null =>
    getAlertCaseSummary(alert, defaultAlertVersion);
};
